import React from 'react';
import {Avatar, ButtonBase, Hidden, makeStyles} from '@material-ui/core';

import {IconMenu2} from '@tabler/icons';

import LogoSection from '../LogoSection';
import Customization from './Customization';

import MobileSection from './MobileSection';

import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1
    },
    headerAvtar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
        background: (props) => props.isTestEnv
            ? 'rgba(183, 28, 28, 0.12)'
            : (theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light),
        color: (props) => props.isTestEnv
            ? '#b71c1c'
            : (theme.palette.mode === 'dark' ? theme.palette.dark.light : theme.palette.purple.dark),
        '&:hover': {
            background: (props) => props.isTestEnv
                ? 'rgba(183, 28, 28, 0.22)'
                : theme.palette.purple.main,
            color: (props) => props.isTestEnv ? '#b71c1c' : theme.palette.purple.light
        }
    },
    testBadge: {
        backgroundColor: '#b71c1c',
        color: '#ffffff',
        fontWeight: 700,
        fontSize: '0.75rem',
        padding: '3px 10px',
        borderRadius: '16px',
        textTransform: 'uppercase',
        letterSpacing: '0.8px',
        marginLeft: '12px',
        display: 'inline-flex',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
        whiteSpace: 'nowrap'
    },
    boxContainer: {
        width: 'auto',
        minWidth: '228px',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: 'auto',
            minWidth: 'auto'
        }
    }
}));

const Header = (props) => {
    const {handleLeftDrawerToggle, isTestEnv} = props;
    const classes = useStyles({ isTestEnv });

    return (
        <React.Fragment>
            <div className={classes.boxContainer}>
                <Hidden mdDown>
                    <LogoSection />
                    <div className={classes.grow} />
                </Hidden>
                <ButtonBase sx={{borderRadius: '12px'}}>
                    <Avatar variant="rounded" className={classes.headerAvtar} onClick={handleLeftDrawerToggle}>
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
                {isTestEnv && (
                    <span className={classes.testBadge}>TEST ENVIRONMENT</span>
                )}
            </div>
            {/* <SearchSection theme="light" /> */}
            <div className={classes.grow} />
            <div className={classes.grow} />            
            <Customization />
            {/* <LocalizationSection />  */}
            <NotificationSection />
            <ProfileSection />
            <Hidden smUp>
                <MobileSection />
            </Hidden>
        </React.Fragment>
    );
};

export default Header;
